import { Injectable, inject } from '@angular/core';
import { Observable, filter, map } from 'rxjs';
import Smartlook from 'smartlook-client';

import { smartlookUserId } from '@app/config';
import { AuthHelpers, AuthService } from '@shared/services/auth';

@Injectable({
    providedIn: 'root',
})
export class SmartLookService {
    private readonly authService = inject(AuthService);

    init() {
        Smartlook.init(smartlookUserId, { region: 'eu' });
    }

    identify(): Observable<void> {
        return this.authService.isAuthenticated().pipe(
            filter(Boolean),
            map(() => {
                const decodeToken = AuthHelpers.decodeToken(this.authService.authToken);
                if (decodeToken?.actor) {
                    const { id, email, firstName, lastName } = decodeToken.actor;
                    Smartlook.identify(id, { email, name: `${firstName || ''} ${lastName || ''}`.trim() });
                }
            }),
        );
    }

    record() {
        Smartlook.record({ emails: true, ips: true, numbers: true });
    }
}
